import React, { useState, useRef } from "react";
import { Modal, Button, Image, Form } from "react-bootstrap";
//import { short_videos_delete_request } from "../../../../../store/actions/SuperAdminActions/adminShortVideosAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
//import restoreimg from "../../../../../assets/images/UserManagement/ResetDrive.svg";
import deleteimg from "../../../../assets/images/UserManagement/Delete.svg";
import {
  pos_mark_for_deletion,
  pos_send_otp__for_deletion,
} from "../../../../store/actions/SuperAdminActions/adminPosconfigurationAdd";
import { TextField } from "@material-ui/core";

const SuperAdminDeletePos = (props) => {
  const [showDeleteshort, seShowDeletShort] = useState(false);
  const [showModalotp, setShowModalotp] = useState(false);
  const [otp, setOTP] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const history = useHistory();
  const token = props?.auth?.user?.accessToken;

  const openModal = () => {
    setShowModalotp(true);
  };

  const closeModal = () => {
    setShowModalotp(false);
  };

  const onSuccessDeleteref = () => {
    seShowDeletShort(false);
    closeModal();

    if (props.onClickCloseView) {
      props.onClickCloseView();
      history.push("/superadminposdashboard");
    }

    if (props.onSuccess) {
      props.onSuccess();
    }
  };

  const onErrorDeleteref = () => {
    seShowDeletShort(false);
  };

  const onSuccessOtpSent = () => {
    openModal();
  };

  const handleDeleteReq = () => {
    pos_send_otp__for_deletion(props.id, token, onSuccessOtpSent, true);
    onDeleteNo();
  };

  const onDeleteNo = () => {
    seShowDeletShort(false);
  };

  const handleShowDeleteOffer = () => {
    seShowDeletShort(true);
  };

  const handleInputChange = (e, index) => {
    const newOTP = [...otp];
    newOTP[index] = e.target.value;
    setOTP(newOTP);

    if (e.target.value === "" && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (index < otp.length - 1 && e.target.value !== "") {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain").trim();
    const pastedOTP = pastedData.slice(0, otp.length);

    if (pastedOTP.length !== otp.length || !/^\d+$/.test(pastedOTP)) {
      // Handle invalid paste
      console.log("Invalid OTP paste");
      return;
    }

    const newOTP = [...otp];
    for (let i = 0; i < pastedOTP.length; i++) {
      newOTP[i] = pastedOTP.charAt(i);
    }
    setOTP(newOTP);

    // Focus on the next input field if available
    if (otp[pastedOTP.length]) {
      inputRefs.current[pastedOTP.length].focus();
    }
  };

  const verifyOTP = () => {
    const enteredOTP = otp.join("");
    pos_mark_for_deletion(
      props.id,
      token,
      onSuccessDeleteref,
      true,
      enteredOTP
    );
    console.log("Entered OTP:", enteredOTP);
  };

  const  MaskedEmail = ( email ) => {

    const [username, domain] = email.split("@");

    const usernameLength = username.length;

    const firstThreeChars = username.substring(0, 3);

    const lastThreeChars = username.substring(
      usernameLength - 3,
      usernameLength
    );

    const maskedEmail = `${firstThreeChars}${"*".repeat(
      usernameLength - 6
    )}${lastThreeChars}@${domain}`;

    return <span>{maskedEmail}</span>;
  }
  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={handleShowDeleteOffer}
      >
        <Image
          src={deleteimg}
          alt="Delete pos"
          title={""}
          fluid
          style={{ width: "16px" }}
        />
      </Button>
      <Modal show={showDeleteshort} onHide={onDeleteNo} centered>
        <Modal.Body className="f16-500">
          Do you want to delete this POS?
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-0">
          <Button
            variant="success"
            className="btn-lg px-5"
            onClick={handleDeleteReq}
          >
            Yes
          </Button>
          <Button
            variant="danger"
            className="btn-lg mr-4 px-5"
            onClick={onDeleteNo}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      <div>
        <Modal
          show={showModalotp}
          onHide={closeModal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {" "}
              <p className="f14-500 text-center">
                OTP had been sent to { MaskedEmail(props?.email)} <br /> For
                verification of deletion of pos
              </p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="otp-input d-flex">
              {otp.map((digit, index) => (
                <TextField
                  key={index}
                  type="text"
                  variant="standard"
                  className="mx-1"
                  value={digit}
                  onPaste={handlePaste}
                  onChange={(e) => handleInputChange(e, index)}
                  inputProps={{ maxLength: 1, style: { textAlign: "center" } }}
                  inputRef={(ref) => (inputRefs.current[index] = ref)}
                />
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <Button variant="success" size="lg" onClick={verifyOTP}>
              Verify
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
};

//export default SuperAdminDeletePos;

SuperAdminDeletePos.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
})(SuperAdminDeletePos);
